"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getMajor = function getMajor(course) {
  if ((course === null || course === void 0 ? void 0 : course.major) === '385' || course.major === 385) {
    return (course === null || course === void 0 ? void 0 : course.otherMajor) && " (".concat(course.otherMajor, ") ");
  }
  return (course === null || course === void 0 ? void 0 : course.majorName) && " (".concat(course.majorName, ")");
};
var _default = getMajor;
exports.default = _default;